export const blockIconsEditorInsertDriveFile = (
	<span className='material-symbols-outlined'>insert_drive_file</span>
);
